import TargetAssignmentActions from './actions';

const INITIAL_STATE = {
  data: {},
  dataAssign: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  showModalTarget:false,
  onSubmit:false,
  single:null,
  helperTargetAssignment:null,
  salesOrderHelperFull:null,
  printTargetAssignment:null
};

function TargetAssignmentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
   case TargetAssignmentActions.RESET_LIST:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,data:{}};
    case TargetAssignmentActions.NEW_DATA:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case TargetAssignmentActions.NEW_DATA_TARGET:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModalTarget:true};
    case TargetAssignmentActions.UPDATE_DATA:
      return { ...state, isProcessing: false, single:null,isNewRecord:false};
    case TargetAssignmentActions.VIEW_DATA:
      return { ...state, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case TargetAssignmentActions.RESET_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form,showModal:false,showModalTarget:false};
    case TargetAssignmentActions.DELETE_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case TargetAssignmentActions.ON_SUBMIT:
      return { ...state, onSubmit:true};
    case TargetAssignmentActions.SHOW_DATA:
      return { ...state,  isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case TargetAssignmentActions.SHOW_DATA_ASSIGN:
      return { ...state,  isError: false, dataAssign: action.payload, errorMessage: [],isProcessing:false };
    case TargetAssignmentActions.SUCCESS_DATA:
      return { ...state, isError: false, showModal:false,showModalTarget:false,form:INITIAL_STATE.form , onSubmit:false};
    case TargetAssignmentActions.PROCESS_DATA:
      return { ...state, isProcessing: true, isError: false,isSuccess:false};
    case TargetAssignmentActions.ERROR_DATA:
      return { ...state,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case TargetAssignmentActions.GET_HELPER_TARGETASSIGNMENT:
      return { ...state, isError: false,isSuccess:false,onSubmit:false,helperTargetAssignment:action.payload};
    case TargetAssignmentActions.GET_HELPER_TARGETASSIGNMENT_FULL:
      return { ...state, isError: false,isSuccess:false,onSubmit:false,salesOrderHelperFull:action.payload};
    case TargetAssignmentActions.PRINT_TARGETASSIGNMENT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printTargetAssignment:null};
    case TargetAssignmentActions.PRINT_TargetAssignment:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printTargetAssignment:action.payload};
    
    default:
      return state;
    }
}


export default TargetAssignmentReducer;
